// extracted by mini-css-extract-plugin
module.exports = {"edit-dictionary-form":"edit-dictionary-form___26brg"};